import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useTheme, SPACING, TYPOGRAPHY } from '../../theme';
import { Avatar } from '../common';
import { Timestamp } from '../../types';

interface OwnerStripProps {
  isOwnedByUser: boolean;
  ownerName?: string;
  claimedAt?: Timestamp;
}

function formatClaimedAt(ts?: Timestamp): string | null {
  if (!ts) return null;
  try {
    const date = ts.toDate();
    return date.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
  } catch {
    return null;
  }
}

export function OwnerStrip({ isOwnedByUser, ownerName, claimedAt }: OwnerStripProps) {
  const { colors } = useTheme();
  const when = formatClaimedAt(claimedAt);
  const label = isOwnedByUser
    ? 'Claimed by you'
    : ownerName
      ? `Claimed by ${ownerName}`
      : 'Claimed';

  return (
    <View style={styles.container}>
      <Avatar
        size={22}
        name={isOwnedByUser ? ownerName || 'You' : ownerName || '·'}
        backgroundColor={colors.progress}
      />
      <Text style={[styles.text, { color: colors.textSecondary }]} numberOfLines={1}>
        <Text style={[styles.labelText, { color: colors.text }]}>{label}</Text>
        {when ? ` · ${when}` : ''}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: SPACING.sm,
    paddingHorizontal: SPACING.xs,
  },
  text: {
    flex: 1,
    ...TYPOGRAPHY.bodySmall,
  },
  labelText: {
    ...TYPOGRAPHY.label,
  },
});
